'use client'

import { CopyButton, AuthSection, EndpointNav, EndpointCard } from '@/components/developer-api'
import { ENDPOINT_DOCS, getApiBaseUrl } from '@/lib/developer-api-docs'

export default function DeveloperApiPage() {
  const baseUrl = getApiBaseUrl()

  return (
    <div className='mx-auto max-w-6xl pb-20'>
      <header className='mb-16 max-w-2xl space-y-4'>
        <h1 className='text-display-2 font-bold text-brand-navy'>Swaasth.ai Developer API</h1>
        <p className='text-base text-muted-foreground'>
          Integrate AI-powered nutrition and recipe generation into your applications.
        </p>
        <div className='flex flex-col gap-3 sm:flex-row sm:items-center'>
          <div className='min-w-0 flex-1'>
            <p className='text-micro mb-1 font-semibold uppercase tracking-widest text-brand-muted'>
              Base URL
            </p>
            <code className='block overflow-x-auto font-mono text-sm text-brand-navy'>{baseUrl}</code>
          </div>
          <CopyButton value={baseUrl} label='Copy Base URL' size='default' />
        </div>
      </header>

      <div className='grid gap-12 lg:grid-cols-[200px_minmax(0,1fr)] xl:grid-cols-[220px_minmax(0,1fr)]'>
        <aside className='hidden lg:block'>
          <EndpointNav />
        </aside>

        <div className='min-w-0 space-y-16'>
          <AuthSection />
          {ENDPOINT_DOCS.map((endpoint) => (
            <EndpointCard key={endpoint.id} endpoint={endpoint} />
          ))}
        </div>
      </div>
    </div>
  )
}
